const partnerAgreement = {
  id: 'partner-agreement-lv',
  title: 'Sadarbības vienošanās',
  body: `
  Партнёрское соглашение доступно по <a href='https://super-ego.info/docs/partner_agreement.pdf' target='_blank'>ссылке</a>.
  `,
}

export default partnerAgreement
